<div class="overview_trainee">
  <fa-icon class="edit" (click)="openDialogAddOrEditTrainee('edit')" [icon]="getFaIcon('faPen')" appChangeColorTheme attribute="color"></fa-icon>
  <div class="profil">
    <div class="img_profil">
      <span>
        {{trainee?.traineeFirstName[0]}}
        {{trainee?.traineeLastName[0]}}
      </span>
    </div>
    <div class="profil_name">
      {{trainee?.traineeFirstName}}
      {{trainee?.traineeLastName}}
    </div>

  </div>

  <div class="infos">
    <div class="info">
      <fa-icon [icon]="getFaIcon('faBirthdayCake')" appChangeColorTheme attribute="color"></fa-icon>
      {{trainee?.traineeBirthDate | date: 'shortDate':'UTC'}}
    </div>
    <div *ngIf="trainee?.licences?.length > 0" class="info licences">
      <fa-icon [icon]="getFaIcon('faIdBadge')" appChangeColorTheme attribute="color"></fa-icon>
      <ul>
        <li *ngFor="let licence of trainee.licences" [matTooltip]="licence.label + ' | ' + licence.licenceValue">{{licence.label}}</li>
      </ul>
    </div>
    <div class="info">
      <fa-icon [icon]="getFaIcon('faHome')" appChangeColorTheme attribute="color"></fa-icon>
      {{trainee?.traineePostalCode}} - {{trainee?.traineeCity}}
    </div>
  </div>

</div>
